import React from "react";
import { Unstable_Popup as BasePopup } from "@mui/base/Unstable_Popup";
import { styled } from "@mui/system";
import { locations } from "../data/Data";
import { Button } from "@mui/base/Button";
import { LoadingButton } from "@mui/lab";
export const Popup = ({ open, checkType, phone, email, location, onClose }) => {
  const selectedLocation = locations.find((loc) => loc.value === location);
  if (!selectedLocation) {
    return null; // or some fallback UI
  }

  const { shopTC, shopEN } = selectedLocation;

  const PopupBody = styled("div")(
    () => `
        width: max-content;
        padding: 60px 30px;
        margin: 12px;
        border-radius: 10px;
        border: 1px solid #DAE2ED;
        background-color: #fff;
        box-shadow:0px 4px 8px rgb(0 0 0 / 0.1);
        z-index: 1;
        text-align: center;
        display: flex;
        flex-direction: column;
    
      `
  );

  return (
    <BasePopup open={open}>
      <PopupBody>
        {checkType == "phone" ? (
          <div>
            The mobile number +852 {phone} has been registered for below
            location.<br></br> 此流動電話號碼+852 {phone}已登記以下地點。
          </div>
        ) : (
          <div>
            This email address {email} has been registered for below timeslot.
            <br></br> 此電郵地址{email}已登記以下地點。
          </div>
        )}
        <br></br>
        地點: {shopTC}
        <br></br> Location:{shopEN}
        <LoadingButton 
          variant="outlined"
          onClick={onClose}
          sx={{ borderRadius: "10px",width:"200px",margin:"auto",marginTop:"20px" }}
        >
          Back | 返回
        </LoadingButton>
      </PopupBody>
    </BasePopup>
  );
};
